import View from "../account/views/OrdersScrollView";
import components from "./components.js";
components.define("js-OrderBlock", View);